import protoRoot from "../proto-root";

const name = "stopMonitoringFromBabyRPCRequest";

function create({ reason }) {
  const StopFromBSRpcReasonCode = protoRoot.lookupEnum(
    "comm.StopFromBSRpcReasonCode"
  );
  const StopMonitoringFromBabyRPCRequest = protoRoot.lookupType(
    "comm.StopMonitoringFromBabyRPCRequest"
  );

  return {
    payload: StopMonitoringFromBabyRPCRequest.create({
      reason: StopFromBSRpcReasonCode.values[reason]
    }),
    name,
    sendBy: "xmpp"
  };
}

export default {
  create,
  name
};
